// import LogRocket from 'logrocket';
import { hydrate, render } from "react-dom";
// import setupLogRocketReact from 'logrocket-react';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { isBuilding } from "utils";

// if(!isBuilding()) {
//   LogRocket.init(process.env.REACT_APP_LRID);
//   setupLogRocketReact(LogRocket);
// }

/** @describe 在 build 的時候要把所有 fetch 都 mock */
if(isBuilding()) {
  // @ts-ignore: Unreachable code error
  window.fetch = () => Promise.resolve({ json: () => Promise.resolve({
    user: {},
    tickets: [],
    part1: {},
    part2: [],
  })});
}

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}

// render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
